module.exports = __webpack_public_path__ + "static/media/hotWaterExplore.f52b5095.png";